import * as React from 'react';
import {Tabs, TabList, TabPanels, TabPanel, Tab} from '@sail/ui';
import {ExamplePanel} from './utils';
import {ResizableContainer} from '../common/ResizableContainer';

export const Disabled = () => {
  return (
    <ResizableContainer minWidth={250} width={500} maxWidth={800}>
      <Tabs size="large" fitted>
        <TabList>
          <Tab>Tab</Tab>
          <Tab>Another Tab</Tab>
          <Tab disabled>Disabled Tab</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ExamplePanel>Test Tab Panel 1</ExamplePanel>
          </TabPanel>
          <TabPanel>
            <ExamplePanel>Test Tab Panel 2</ExamplePanel>
          </TabPanel>
          <TabPanel>
            <ExamplePanel>Test Tab Panel 3</ExamplePanel>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </ResizableContainer>
  );
};
